import { useSnapshot } from 'valtio'
import { activeModalStack, hideAllModals, openOptionsMenu } from '../../globalState'
import { ChatSizeField, guiOptionsScheme, OptionsGroupType } from '../../optionsGuiScheme'
import { useIsModalActive } from '../utilsApp'
import {
  NavCard, NavCards, SettingsDivider, SettingsPanel, SettingsScreen
} from './SettingsUi'
import { RenderQualityField } from './RenderQualityField'
import { OverlayScreen } from './OverlayScreen'
import { ChatScreen } from './ChatScreen'
import { RenderScreen } from './RenderScreen'

/** The three modules reachable from the root settings screen, in card order. */
const NAV_GROUPS: Array<{ group: OptionsGroupType, label: string }> = [
  { group: 'render', label: 'Рендер' },
  { group: 'hud', label: 'Оверлеи' },
  { group: 'chat', label: 'Чат' },
]

export const RootScreen = () => <SettingsScreen title='Настройки'>
  <RenderQualityField />
  <ChatSizeField />
  <SettingsDivider />
  <NavCards>
    {NAV_GROUPS.map(({ group, label }, i) => (
      <NavCard
        key={group}
        label={label}
        wide={i === NAV_GROUPS.length - 1 && NAV_GROUPS.length % 2 === 1}
        onClick={() => openOptionsMenu(group)}
      />
    ))}
  </NavCards>
</SettingsScreen>

export default () => {
  useIsModalActive('options-*')
  const stack = useSnapshot(activeModalStack)
  const { reactType } = stack.at(-1) ?? {}
  if (!reactType?.startsWith('options-')) return null
  // Back only makes sense when this screen was opened from another settings screen.
  const canGoBack = stack.at(-2)?.reactType?.startsWith('options-') ?? false
  const groupName = reactType.slice('options-'.length)
  if (!(groupName in guiOptionsScheme)) return null
  const group = groupName as OptionsGroupType

  return <SettingsPanel onClose={hideAllModals}>
    {group === 'main' && <RootScreen />}
    {group === 'render' && <RenderScreen canGoBack={canGoBack} />}
    {group === 'hud' && <OverlayScreen canGoBack={canGoBack} />}
    {group === 'chat' && <ChatScreen canGoBack={canGoBack} />}
  </SettingsPanel>
}
